<template>
  <div>
    <v-stepper vertical v-model="currentStep" :non-linear="editFlow">
      <template v-for="(item, index) in steps">
        <v-stepper-step
          :key="index"
          step
          :editable="editFlow"
          :complete="currentStep > index"
          :class="currentStep == index ? 'activeStep' : ''"
          @click="changeStep(index)"
          :autoid="item.autoid"
        >{{ item.displayName }}</v-stepper-step>
      </template>
    </v-stepper>
  </div>
</template>

<script>
import Vue from 'vue'
import Vuex from 'vuex'
import { mapActions } from 'vuex'
Vue.use(Vuex)
export default {
  name: 'stepper',
  inject: ['$validator'],
  data() {
    return {
      config: this.stepperConfig,
      editFlow: this.stepperConfig.editFlow
    }
  },
  props: {
    stepperConfig: Object
  },
  computed: {
    currentStep: {
      set() {
        this.$store.state.createSubbrandStore.currentStep
      },
      get() {
        return this.$store.state.createSubbrandStore.currentStep
      }
    },
    steps() {
      let templateData = this.$store.state.createSubbrandStore
        .createTemplateData
      let content = templateData.content
      let stepData = []
      for (let i = 0; i <= content.length - 1; i++) {
        let stepsInfo = {}
        stepsInfo.displayName = content[i].stepDisplayName
        stepsInfo.order = content[i].stepOrder
        stepsInfo.autoid = content[i].autoid
        stepData.push(stepsInfo)
      }
      return stepData
    }
  },
  methods: {
    ...mapActions(['formDataConstruct']),
    changeStep(clickedStep) {
      if (this.editFlow) {
        let _currentStep = this.$store.state.createSubbrandStore.currentStep
        if (_currentStep !== clickedStep) {
          if (this.errors && this.errors.items.length == 0) {
            // Move forward or backward
            this.$store.state.createSubbrandStore.currentStep = clickedStep
            this.formDataConstruct()

            // Move the focus to top element
            window.scrollTo(0, 0)

            // Set focus to form element
            document.getElementById('back-to-sub-brand-list-btn').focus()
          }
        }
      }
    }
  }
}
</script>
